// 法人情報の編集コメントを生成
import React, { memo } from 'react';
import ValidMessage from '../atoms/ValidMessage';
import { ValidMessageType } from '../types/Corporate';
import { FormNameKey } from '../const/Corporate';

interface Props {
  margin: string;
  edit_comment: string;
  setEditComment: React.Dispatch<React.SetStateAction<string>>;
  valid_message: ValidMessageType[];
}
const CorporateCreateEditComment: React.FC<Props> = ({ margin, edit_comment, setEditComment, valid_message }) => {
  /**
   * バリデーションエラーがあるか判定する処理
   * @param name アイテムのキー名
   * @returns index
   */
  const findValidMessageIndex = (messages: ValidMessageType[]) => {
    if (messages.length === 0) return -1;

    return messages.findIndex((message: ValidMessageType) => message.form_name === FormNameKey.temp_comment);
  };

  return (
    <dl className={`field_section ${margin}`}>
      <dt className="field_label">編集コメント</dt>
      <dd className="field_data">
        <input
          className={`${findValidMessageIndex(valid_message) !== -1 ? 'form-control-error' : 'form-control'} w-100`}
          defaultValue={edit_comment}
          type="text"
          onBlur={e => setEditComment(e.target.value)}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.currentTarget.blur();
            }
          }}
        />
        {findValidMessageIndex(valid_message) !== -1 && (
          <span className="valid_message">
            <ValidMessage message={valid_message[findValidMessageIndex(valid_message)].message} />
          </span>
        )}
      </dd>
    </dl>
  );
};

export default memo(CorporateCreateEditComment);
